import { useState, useEffect, forwardRef } from "react";
import TextAreaBase from "./FieldTypeBase/TextAreaBase";
import ReactDOM from "react-dom";

const TextAreaInLine = forwardRef((props, ref) => {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    let attempts = 0;
    const interval = setInterval(() => {
        const el = document.getElementById(props.field.containerId);
        if (el) {
        setContainer(el);
        clearInterval(interval);
        } else if (attempts++ > 10) {
        clearInterval(interval);
        console.warn("Portal container not found:", props.field.containerId);
        }
    }, 100); // retry every 100ms up to 1s

  return () => clearInterval(interval);
}, [props.field.containerId]);

  if (!container) return null;

  return ReactDOM.createPortal(
    <span
      key={props.objectkey}
      id={props.objectkey}
      className={`field ${props.field.class || ""}`}
    >
      {/* ✅ Forward the ref to the actual input */}
      <TextAreaBase {...props} ref={ref} />
    </span>,
    container
  );
});

export default TextAreaInLine;